import { useState, useEffect } from 'react';

const TABLET_BREAKPOINT = 1023;

function getInitialIsTablet(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  return window.matchMedia(`(max-width: ${TABLET_BREAKPOINT}px)`).matches;
}

/**
 * Returns whether the viewport is tablet size (834×1194 or smaller width).
 * Used to render a different auth layout without the animated orbit.
 * Initial value is read synchronously so tablet never loads the orbit chunk.
 */
export function useAuthViewport(): { isTablet: boolean } {
  const [isTablet, setIsTablet] = useState(getInitialIsTablet);

  useEffect(() => {
    const mediaQuery = window.matchMedia(`(max-width: ${TABLET_BREAKPOINT}px)`);

    const handleChange = (e: MediaQueryListEvent) => {
      setIsTablet(e.matches);
    };

    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return { isTablet };
}
